import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useLocation } from "wouter";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import { guardarIdiomaManual } from "../lib/idioma";
import { useHistorico } from "../contexts/HistoricoContext";

// Português / Español na barra do topo, à direita (onde ficava o botão "Ajuda" da biblioteca).
// A barra é do empreender-ui e não aceita filhos: o seletor entra nela por portal, sem editar os
// arquivos da biblioteca (que o CLI sobrescreve a cada atualização).
const SeletorIdioma = () => {
  const { t } = useTranslation();
  const [location, setLocation] = useLocation();
  const { recarregarHistorico } = useHistorico();
  const [barra, setBarra] = useState<Element | null>(null);

  useEffect(() => {
    setBarra(document.querySelector(".empreender-lib-topbar"));
  }, []);

  const idioma = i18n.language === "es" ? "es" : "pt";

  const trocar = (novo: "pt" | "es") => {
    if (novo === idioma) return;
    // A escolha manual passa a valer sobre a detecção automática nas próximas visitas.
    guardarIdiomaManual(novo);
    i18n.changeLanguage(novo);
    setLocation(/\/(pt|es)$/.test(location) ? location.replace(/\/(pt|es)$/, `/${novo}`) : `/${novo}`);
    recarregarHistorico();
  };

  if (!barra) return null;

  return createPortal(
    <div className="seletor-idioma" role="group" aria-label={t("idioma")}>
      <button className={idioma === "pt" ? "ativo" : ""} aria-pressed={idioma === "pt"} onClick={() => trocar("pt")}>
        <span className="nome-longo">Português</span>
        <span className="nome-curto">PT</span>
      </button>
      <button className={idioma === "es" ? "ativo" : ""} aria-pressed={idioma === "es"} onClick={() => trocar("es")}>
        <span className="nome-longo">Español</span>
        <span className="nome-curto">ES</span>
      </button>
    </div>,
    barra
  );
};

export default SeletorIdioma;
